import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

import { freeBuildsPath } from './freeBuildsPath';

export type FreeBuilds = { available: boolean; used: number; limit: number };

const useFreeBuildsShow = (params: { workspaceSlug: string }, opts?: UseMonolithApiQueryOptions<FreeBuilds, never>) =>
  useMonolithApiQuery<FreeBuilds, never>(['free_builds', params.workspaceSlug], freeBuildsPath(params), opts);

export default useFreeBuildsShow;
